module.exports = __webpack_public_path__ + "img/top-1-1.408fb468.jpg";